import {
    SHOPCART_ADD_EVENT, SHOPCART_ERROR, SHOPCART_RESET_ERROR, SHOPCART_REMOVE_EVENT, SHOPCART_ADD_TOUR_PRODUCT,
    SHOPCART_REMOVE_TOUR_PRODUCT, SHOPCART_RESET_STATE, SHOPCART_SET_TOUR_PRODUCT_QUANTITY,
    SHOPCART_SET_TOUR_PRODUCT_QUANTITY_WITH_TOURHOLD_LOADING,
    SHOPCART_REMOVE_TOUR_PRODUCT_WITH_TOURHOLD_LOADING,
    SHOPCART_APPLYCOUPON_TO_EVENTS, SHOPCART_APPLYCOUPON_TO_GATICKETS, REMOVE_COUPON,
    SHOPCART_ADD_GIFTCARD, SHOPCART_DELETE_GIFTCARD,
    SHOPCART_UPDATE_GIFTCARD, SHOPCART_COUPONAPPLIED_RESET, SHOPCART_COUPONREMOVE_RESET,
    SHOPCART_APPLY_MEMBERSHIP_COSTRATES_ON_EVENTS, SHOPCART_REMOVE_ALL_COUPONS,
    SHOPCART_RESET_GIFTCARDS, SHOPCART_RESET_MEMBERSHIP, SHOPCART_RESET_IDME
    , SHOPCART_UPDATE_MEMBERSHIPEMAIL, SHOPCART_APPLY_DONATION, SHOPCART_RESET_DONATION,
    UPDATE_DONATION_POPUP_INCREASE, RESET_DONATION_POPUP_INCREASE, SHOPCART_ADD_MEMBERSHIP_PACKAGE, SHOPCART_RESET_MEMBERSHIP_PACKAGE,
    SHOPCART_GATICKET_ADD, SHOPCART_GATICKET_REMOVE, SHOPCART_GATICKET_UPDATE_QUANTITY, SHOPCART_RESET_GATICKET,
    SHOPCART_REMOVE_GATICKET_COUPONS, SHOPCART_APPLYCOUPON_TO_MEMBERSHIP_PACKAGE, SHOPCART_REMOVECOUPON_FROM_MEMBERSHIPTYPE, SHOPCART_SET_MANAGEMYBOOKING,
    SHOPCART_SET_REFUNDTYPE, SHOPCART_SET_ADDITIONALBOOKING_AMOUNT, SHOPCART_SET_MMB_AMOUNT_TO_PAY, SHOPCART_SET_ENTERED_AMOUNT_TO_PAY, SHOPCART_APPLY_MEMBER_COSTRATE,
    SHOPCART_APPLY_IDME_COSTRATES_ON_EVENTS, SHOPCART_ADD_ORDER_PRODUCT, SHOPCART_UPDATE_ORDER_PRODUCT, SHOPCART_DELETE_ORDER_PRODUCT,
    SHOPCART_UPDATE_ORDER_PRODUCTS, SHOPCART_RESET_ORDER_PRODUCTS,
    SHOPCART_VERIFY_VALID_MEMBER, SHOPCART_SHOW_TRANSACTION_FEE, SHOPCART_UPDATE_DONATION_PRODUCT,
    SHOPCART_DELETE_DONATION_PRODUCT, SHOPCART_RESET_DONATION_PRODUCT

} from "../actions/actionShopCart";
import { genfunction } from 'helpers';
import { loadState, saveState } from "../helpers/sessionStorage";
import { CouponManager } from 'helpers';
const { DefaultCostRateID } = window['runConfig'];

const sessionKey = "ShopCartEvents";
const sessionKey2 = "ShopCartCashless";
const sessionKey3 = "CouponCodes";
const sessionKey4 = "TourProducts";
const sessionKey5 = "UseMembershipValidation";
const sessionKey6 = "UseDonation";
const sessionKey7 = "MembershipPackages";
const sessionKey8 = "GATickets";
const sessionKey9 = "ManageMyBooking";
const sessionKey10 = "ManageBookingAppliedTicketsModification";
const sessionKey11 = "RefundType";
const sessionKey12 = "MMBAmountToPay";
const sessionKey13 = "IDMEApply";
const sessionKey14 = "ShopCartOrderProduct";
const sessionKey15 = "ShopCartShowTransFee";
const sessionKey16 = "DonationProducts";
const sessionKey17 = "EnteredAmountToPay";

const initialState = {
    events: loadState(sessionKey, []),
    cashless: loadState(sessionKey2, []),
    tourCoupons: loadState(sessionKey3, []),
    tourProducts: loadState(sessionKey4, []),
    loading: false,
    couponAlreadyApplied: false,
    removeCoupon: '',
    membershipValidation: loadState(sessionKey5, {
        ismembershipApplied: false,
        membershipcostrate: DefaultCostRateID,
        membershipMembrNo: 0,
        memberEmail: "",
        memberLastName: "",
        applycostRates: false
    }),
    donation: loadState(sessionKey6, {
        isdonationApplied: false,
        productID: 0,
        productName: '',
        otherAmount: false,
        price: 0,
        popupCounts: 0,
        UseAlternateMerchantOnline: false
    }),
    MembershipPackages: loadState(sessionKey7, []),
    GATickets: loadState(sessionKey8, []),
    membershipIsRenew: false,
    managemybooking: loadState(sessionKey9, false),
    managebookingticketsmodification: loadState(sessionKey10, false),
    refundType: loadState(sessionKey11, ''),
    additionalbookingamount: 0,
    mmbAmountToPay: loadState(sessionKey12, 0),
    IDME: loadState(sessionKey13, {
        isIdMeApplied: false,
        idmecostrate: DefaultCostRateID
    }),
    orderProducts: loadState(sessionKey14, []),
    showTransactionFee: loadState(sessionKey15, false),
    donationProducts: loadState(sessionKey16, []),
    enteredAmountToPay: loadState(sessionKey17, 0),
    error: ''
};

function reducerShopCart(state = initialState, action) {
    switch (action.type) {
        case SHOPCART_ADD_EVENT: {

            let newevents = [
                ...state.events
            ]

            if (genfunction.IsNotNullOrEmptyOrUndefined(action.paymentOption))
                genfunction.CalculateEventFlexibleAmount(action.payload, action.paymentOption, action.amountSelected);

            if (newevents.filter(x => x.TourEventID === action.payload.TourEventID).length > 0) {
                let eventIndex = newevents.findIndex(x => x.TourEventID === action.payload.TourEventID);
                newevents[eventIndex] = genfunction.UpdateEvent(newevents, action.payload, action.isEditEvent);
            }
            else {
                newevents = [
                    ...state.events,
                    action.payload
                ]
            }

            //Update Coupons
            let trcoupons = [
                ...state.tourCoupons
            ]

            let trProducts = [
                ...state.tourProducts
            ]

            newevents = genfunction.calculateeventsamount(newevents);
            CouponManager.ApplyCouponsToEvents(newevents, trcoupons, trProducts);

            newevents.filter(e => e.TourEventID == action.payload.TourEventID).map(e => {
                e.OrganizationID = genfunction.IsNotNullOrEmptyOrUndefined(action.organizationID) ? action.organizationID : "";
                e.GroupSize = action.groupSize;
            });

            saveState(sessionKey, newevents);

            return { ...state, events: newevents, loading: false };
        }
        case SHOPCART_REMOVE_EVENT: {

            let newevents = [
                ...state.events
            ]
            newevents = newevents.filter((item) => {
                return item.TourEventID !== action.payload;
            });

            newevents = genfunction.calculateeventsamount(newevents);

            saveState(sessionKey, newevents);

            return {
                ...state,
                events: newevents,
                error: '',
                loading: false
            };
        }
        case SHOPCART_ADD_TOUR_PRODUCT: {

            let newevents = [
                ...state.events
            ]
            newevents = newevents.map(obj => {
                if (obj.TourEventID === action.payload.TourEventID) {
                    obj.TourProducts.push(action.payload.tourprduct);
                }
                return obj;
            });
            newevents = genfunction.calculateeventsamount(newevents);

            saveState(sessionKey, newevents);

            return {
                ...state,
                events: newevents,
                loading: false
            };
        }
        case SHOPCART_REMOVE_TOUR_PRODUCT: {

            let newevents = [
                ...state.events
            ]
            let noproducteventid = 0;
            newevents = newevents.map(obj => {
                if (obj.TourEventID === action.payload.TourEventID) {
                    obj.TourProducts = obj.TourProducts.filter(tproduct => tproduct.TourProductID !== action.payload.TourProductID);
                    if (obj.TourProducts.length === 0) {
                        noproducteventid = obj.TourEventID;
                    }
                }
                return obj;
            });

            if (noproducteventid > 0) {
                newevents = newevents.filter(event => event.TourEventID !== noproducteventid)
            }

            //Update Coupons
            let trcoupons = [
                ...state.tourCoupons
            ]

            let trProducts = [
                ...state.tourProducts
            ]

            newevents = CouponManager.RemoveProductItem(newevents, action.payload.TourEventID, action.payload.TourProductID);
            newevents = genfunction.calculateeventsamount(newevents);

            trcoupons = CouponManager.RemoveUnusedCoupon(trcoupons, newevents);
            CouponManager.ApplyCouponsToEvents(newevents, trcoupons, trProducts);
            saveState(sessionKey, newevents);

            return {
                ...state,
                events: newevents,
                tourCoupons: trcoupons,
                loading: false
            };
        }
        case SHOPCART_SET_TOUR_PRODUCT_QUANTITY: {

            let newevents = [
                ...state.events
            ]
            newevents = newevents.map(obj => {
                if (obj.TourEventID === action.payload.TourEventID) {
                    obj.TourProducts.find(tproduct => tproduct.TourProductID == action.payload.TourProductID).Quantity = action.payload.Quantity;
                }
                return obj;
            });

            newevents = genfunction.calculateeventsamount(newevents);

            //Update Coupons
            let trcoupons = [
                ...state.tourCoupons
            ]

            let trProducts = [
                ...state.tourProducts
            ]

            newevents = genfunction.calculateeventsamount(newevents);
            CouponManager.ApplyCouponsToEvents(newevents, trcoupons, trProducts);
            saveState(sessionKey, newevents);

            return {
                ...state,
                events: newevents,
                loading: false,
                error: ''
            };
        }
        case SHOPCART_RESET_STATE: {

            var membershipObj = {
                ismembershipApplied: false,
                membershipcostrate: DefaultCostRateID,
                membershipMembrNo: 0,
                memberEmail: "",
                memberLastName: "",
                applycostRates: false
            };

            var donationObj = {
                isdonationApplied: false,
                productID: 0,
                productName: '',
                otherAmount: false,
                price: 0,
                popupCounts: 0,
                UseAlternateMerchantOnline: false
            };

            var idmeObj = {
                isIdMeApplied: false,
                idmecostrate: DefaultCostRateID
            };

            saveState(sessionKey, []);
            saveState(sessionKey2, []);
            saveState(sessionKey3, []);
            saveState(sessionKey4, []);
            saveState(sessionKey5, membershipObj);
            saveState(sessionKey6, donationObj);
            saveState(sessionKey7, []);
            saveState(sessionKey8, []);
            saveState(sessionKey9, false);
            saveState(sessionKey10, false);
            saveState(sessionKey11, '');
            saveState(sessionKey12, 0);
            saveState(sessionKey13, idmeObj);
            saveState(sessionKey14, []);
            saveState(sessionKey15, false);
            saveState(sessionKey16, []);
            saveState(sessionKey17, 0);
            return {
                ...state,
                events: [],
                tourCoupons: [],
                tourProducts: [],
                loading: false,
                cashless: [],
                couponAlreadyApplied: false,
                removeCoupon: '',
                membershipValidation: membershipObj,
                donation: donationObj,
                MembershipPackages: [],
                GATickets: [],
                membershipIsRenew: false,
                managemybooking: false,
                managebookingticketsmodification: false,
                refundType: '',
                additionalbookingamount: 0,
                mmbAmountToPay: 0,
                IDME: idmeObj,
                orderProducts: [],
                showTransactionFee: false,
                donationProducts: [],
                enteredAmountToPay: 0,
                error: ''
            };
        }

        case SHOPCART_SET_TOUR_PRODUCT_QUANTITY_WITH_TOURHOLD_LOADING: {
            return {
                ...state,
                loading: true
            };
        }
        case SHOPCART_REMOVE_TOUR_PRODUCT_WITH_TOURHOLD_LOADING: {
            return {
                ...state,
                loading: true
            };
        }

        case SHOPCART_APPLYCOUPON_TO_EVENTS: {

            //Save Coupon
            let trcoupons = [
                ...state.tourCoupons
            ]

            if (trcoupons.length > 0 && trcoupons.filter(x => x.CouponID == action.tourCoupon[0].CouponID).length > 0) {
                trcoupons = trcoupons.filter(x => x.CouponID != action.tourCoupon[0].CouponID);
            }

            action.tourCoupon[0].CouponHoldRef = action.CouponHoldRef;

            if (action.tourCoupon[0].RequireUniqueCouponCode) {
                action.tourCoupon[0].MaxProductsLimit = action.tourCoupon[0].MaxProductsPerPurchase;
            }

            trcoupons.push(action.tourCoupon[0]);

            //Save Tour Product
            let trProducts = [
                ...state.tourProducts
            ]

            if (trProducts.filter(x => x.TourProductID == action.tourProduct[0].TourProductID).length > 0) {
                trProducts = trProducts.filter(x => x.TourProductID != action.tourProduct[0].TourProductID);
            }

            trProducts.push(action.tourProduct[0]);
            saveState(sessionKey4, trProducts);

            //Apply Coupons and Update Events
            let newevents = [
                ...state.events
            ]

            let couponAlreadyApply = false;
            let isRemoveCoupon = false;

            newevents = genfunction.calculateeventsamount(newevents);
            couponAlreadyApply = CouponManager.ApplyCouponsToEvents(newevents, trcoupons, trProducts, couponAlreadyApply, action.couponCode);


            saveState(sessionKey, newevents);
            saveState(sessionKey3, trcoupons);

            if (action.tourCoupon[0].RequireUniqueCouponCode) {
                isRemoveCoupon = CouponManager.RemoveUniqueCouponNotApplied(newevents, action.CouponHoldRef);

                if (isRemoveCoupon) {
                    trcoupons = trcoupons.filter(x => x.RequireUniqueCouponCode && x.CouponID != action.tourCoupon[0].CouponID);
                    saveState(sessionKey3, trcoupons);
                }
            }

            return {
                ...state,
                events: newevents,
                tourCoupons: trcoupons,
                tourProducts: trProducts,
                loading: false,
                couponAlreadyApplied: couponAlreadyApply,
                removeCoupon: isRemoveCoupon ? action.CouponHoldRef : ''
            };
        }

        case SHOPCART_APPLYCOUPON_TO_GATICKETS: {
            let tickets = [
                ...state.GATickets
            ]

            let newtickets = tickets.map(ticket => {
                let couponproduct = action.payload.GATickets.find(x => x.ProductID === ticket.ProductID);
                if (couponproduct && couponproduct.Price < couponproduct.OriginalPrice) {
                    ticket.Price = couponproduct.Price;
                    ticket.OriginalPrice = couponproduct.OriginalPrice
                    ticket.CouponCodeApplied = action.payload.CouponCode;
                }
                return ticket;
            })

            newtickets = genfunction.calculategaticketamount(newtickets);

            saveState(sessionKey8, newtickets);
            return {
                ...state,
                GATickets: newtickets
            };
        }

        case REMOVE_COUPON: {

            let newevents = [
                ...state.events
            ]

            let newcouponTours = [
                ...state.tourCoupons
            ]

            //Update Coupon MaxProductLimit Quantity, if Coupon is Unique.
            newcouponTours = CouponManager.UpdateMaxProductLimit(newcouponTours, newevents, action.payload.TourEventID, action.payload.TourProductID);

            newevents = CouponManager.RemoveProductItem(newevents, action.payload.TourEventID, action.payload.TourProductID)
            newevents = genfunction.calculateeventsamount(newevents);
            saveState(sessionKey, newevents);

            //Remove Coupon, if not in used.
            newcouponTours = CouponManager.RemoveUnusedCoupon(newcouponTours, newevents);

            saveState(sessionKey3, newcouponTours);

            return {
                ...state,
                events: newevents,
                tourCoupons: newcouponTours,
                loading: false
            };
        }
        case SHOPCART_ADD_GIFTCARD: {
            let newcashless = [
                ...state.cashless,
                action.payload
            ]

            saveState(sessionKey2, newcashless);

            return { ...state, cashless: newcashless, loading: false };
        }
        case SHOPCART_UPDATE_GIFTCARD: {
            saveState(sessionKey2, action.payload);
            return { ...state, cashless: action.payload, loading: false };
        }
        case SHOPCART_DELETE_GIFTCARD: {

            let newcashless = [
                ...state.cashless
            ]
            newcashless = newcashless.filter((item) => {
                return item.GiftcardHoldRef !== action.payload;
            });

            saveState(sessionKey2, newcashless);

            return {
                ...state,
                cashless: newcashless,
                loading: false
            };
        }

        case SHOPCART_COUPONAPPLIED_RESET: {
            return {
                ...state,
                loading: false,
                couponAlreadyApplied: false
            };
        }
        case SHOPCART_COUPONREMOVE_RESET: {
            return {
                ...state,
                loading: false,
                removeCoupon: ''
            };
        }
        default: {
            return state;
        }

        case SHOPCART_APPLY_MEMBERSHIP_COSTRATES_ON_EVENTS: {

            let newevents = [
                ...state.events
            ]


            newevents = genfunction.ApplyMembershipPricesOnEvents(newevents, action.payload.costrate, action.payload.extraitems, DefaultCostRateID);

            var membershipObj = {
                ismembershipApplied: true,
                membershipcostrate: action.payload.costrate,
                membershipMembrNo: action.payload.memberNo,
                memberEmail: action.payload.memberEmail,
                memberLastName: action.payload.memberLastName,
                applycostRates: true
            }

            var idmeObj = {
                isIdMeApplied: false,
                idmecostrate: DefaultCostRateID
            }

            saveState(sessionKey, newevents);
            saveState(sessionKey5, membershipObj)
            saveState(sessionKey13, idmeObj)

            return {
                ...state,
                events: newevents,
                membershipValidation: membershipObj,
                IDME: idmeObj
            };

        }

        case SHOPCART_VERIFY_VALID_MEMBER: {


            var membershipObj = {
                ismembershipApplied: true,
                membershipcostrate: action.payload.costrate,
                membershipMembrNo: action.payload.memberNo,
                memberEmail: action.payload.memberEmail,
                memberLastName: action.payload.memberLastName,
                applycostRates: false
            }

            saveState(sessionKey5, membershipObj)

            return {
                ...state,
                membershipValidation: membershipObj,
            };
        }


        case SHOPCART_REMOVE_ALL_COUPONS: {

            let newevents = [
                ...state.events
            ]

            newevents = newevents.map(obj => {

                //obj.coupon
                obj.CouponItems = [];

                return obj;
            });

            newevents = genfunction.calculateeventsamount(newevents);


            saveState(sessionKey, newevents);
            saveState(sessionKey3, []);
            saveState(sessionKey4, []);

            return {
                ...state,
                tourCoupons: [],
                tourProducts: [],
                loading: false,
                couponAlreadyApplied: false,
                removeCoupon: ''
            };
        }
        case SHOPCART_RESET_GIFTCARDS: {
            saveState(sessionKey2, []);

            return {
                ...state,
                loading: false,
                cashless: []
            };
        }

        case SHOPCART_RESET_MEMBERSHIP: {

            var membershipObj = {
                ismembershipApplied: false,
                membershipcostrate: DefaultCostRateID,
                membershipMembrNo: 0,
                memberEmail: "",
                memberLastName: "",
                applycostRates: false
            }

            saveState(sessionKey5, membershipObj)

            return {
                ...state,
                membershipValidation: membershipObj
            };

        }
        case SHOPCART_RESET_IDME: {

            var idmeObj = {
                isIdMeApplied: false,
                idmecostrate: DefaultCostRateID
            }
            saveState(sessionKey13, idmeObj)

            return {
                ...state,
                IDME: idmeObj
            };

        }
        case SHOPCART_UPDATE_MEMBERSHIPEMAIL: {

            var membershipObj = {
                ...state.membershipValidation
            }

            membershipObj.memberEmail = action.payload;

            saveState(sessionKey5, membershipObj)

            return {
                ...state,
                membershipValidation: membershipObj
            };

        }

        case SHOPCART_APPLY_DONATION: {

            var donationObj = {
                ...state.donation
            }

            donationObj.isdonationApplied = true;
            donationObj.productID = action.payload.productID;
            donationObj.productName = action.payload.productName;
            donationObj.price = action.payload.price;
            donationObj.otherAmount = action.payload.othersAmount;
            donationObj.UseAlternateMerchantOnline = action.payload.useAlternateMerchantOnline;

            saveState(sessionKey6, donationObj);

            return {
                ...state,
                donation: donationObj
            }
        }

        case SHOPCART_RESET_DONATION: {
            var donationObj = {
                ...state.donation
            }

            donationObj.isdonationApplied = false;
            donationObj.productID = 0;
            donationObj.productName = '';
            donationObj.price = 0;
            donationObj.otherAmount = false;
            donationObj.UseAlternateMerchantOnline = false;


            saveState(sessionKey6, donationObj);

            return {
                ...state,
                donation: donationObj
            }
        }

        case UPDATE_DONATION_POPUP_INCREASE: {

            var donationObj = {
                ...state.donation
            }

            donationObj.popupCounts = 1;
            saveState(sessionKey6, donationObj);

            return {
                ...state,
                donation: donationObj
            }
        }

        case RESET_DONATION_POPUP_INCREASE: {

            var donationObj = {
                isdonationApplied: false,
                productID: 0,
                productName: '',
                otherAmount: false,
                price: 0,
                popupCounts: 0,
                UseAlternateMerchantOnline: false
            };

            saveState(sessionKey6, donationObj);

            return {
                ...state,
                donation: donationObj
            }
        }

        case SHOPCART_ADD_MEMBERSHIP_PACKAGE: {

            var membershipPackagesObj = [...state.MembershipPackages];

            membershipPackagesObj = membershipPackagesObj.filter(function (el) {
                return el != null;
            });

            if (membershipPackagesObj && membershipPackagesObj.filter(x => x.MembershipPackageID === action.payload.MembershipPackageID).length > 0) {
                let memberPackIndex = membershipPackagesObj.findIndex(x => x.MembershipPackageID === action.payload.MembershipPackageID);
                membershipPackagesObj[memberPackIndex] = action.payload;
            }
            else {
                membershipPackagesObj.push(action.payload);
            }


            membershipPackagesObj = genfunction.CalculateMembershipPackages(membershipPackagesObj);

            saveState(sessionKey7, membershipPackagesObj);

            return {
                ...state, MembershipPackages: membershipPackagesObj,
                membershipIsRenew: action.isRenew
            }
        }

        case SHOPCART_RESET_MEMBERSHIP_PACKAGE: {
            saveState(sessionKey7, []);

            return {
                ...state,
                MembershipPackages: []
            };
        }

        case SHOPCART_GATICKET_ADD: {
            let gatickets = [
                ...state.GATickets
            ]
            action.payload.forEach(ticket => {

                let existticket = gatickets.find(x => x.ProductID === ticket.ProductID)
                if (existticket) {
                    existticket.Quantity += ticket.Quantity;
                }
                else {
                    gatickets.push(ticket);
                }
            });

            gatickets = genfunction.calculategaticketamount(gatickets);
            saveState(sessionKey8, gatickets);
            return {
                ...state,
                GATickets: gatickets
            };
        }

        case SHOPCART_GATICKET_REMOVE: {
            let gatickets = [
                ...state.GATickets
            ]
            gatickets = gatickets.filter(x => (x.ProductID === action.payload.ProductID) ? false : true);

            gatickets = genfunction.calculategaticketamount(gatickets);
            saveState(sessionKey8, gatickets);
            return {
                ...state,
                GATickets: gatickets
            };
        }

        case SHOPCART_GATICKET_UPDATE_QUANTITY: {
            let gatickets = [
                ...state.GATickets
            ]
            let existticket = gatickets.find(x => x.ProductID === action.payload.ProductID)
            if (existticket && existticket.Quantity > 0) {
                existticket.Quantity = action.payload.Quantity;
            }
            else {
                gatickets = gatickets.filter(x => x.ProductID !== action.payload.ProductID);
            }

            gatickets = genfunction.calculategaticketamount(gatickets);
            saveState(sessionKey8, gatickets);
            return {
                ...state,
                GATickets: gatickets
            };
        }

        case SHOPCART_RESET_GATICKET: {
            saveState(sessionKey8, []);

            return {
                ...state,
                GATickets: []
            };
        }

        case SHOPCART_RESET_ORDER_PRODUCTS: {
            saveState(sessionKey14, []);

            return {
                ...state,
                orderProducts: []
            };
        }

        case SHOPCART_REMOVE_GATICKET_COUPONS: {

            let gatickets = [
                ...state.GATickets
            ]

            let newtickets = gatickets.map(ticket => {
                if (ticket.CouponCodeApplied && ticket.CouponCodeApplied == action.payload) {
                    ticket.CouponCodeApplied = null;
                    ticket.Price = ticket.OriginalPrice;
                }
                return ticket;
            })
            gatickets = genfunction.calculategaticketamount(newtickets);
            saveState(sessionKey8, newtickets);
            return {
                ...state,
                GATickets: newtickets
            };
        }

        case SHOPCART_APPLYCOUPON_TO_MEMBERSHIP_PACKAGE: {
            let membershipPackagesObj = [...state.MembershipPackages];

            membershipPackagesObj[0].MembershipProducts = genfunction.ApplyMembershipCoupon(membershipPackagesObj[0].MembershipProducts, action.payload.MembershipPackages, action.payload.CouponCode);

            saveState(sessionKey7, membershipPackagesObj);

            return {
                ...state, MembershipPackages: membershipPackagesObj
            }
        }

        case SHOPCART_REMOVECOUPON_FROM_MEMBERSHIPTYPE: {
            let membershipPackagesObj = [...state.MembershipPackages];

            membershipPackagesObj[0].MembershipProducts = membershipPackagesObj[0].MembershipProducts.map(m => {
                if (m.MembershipTypeID == action.payload) {
                    m.CouponCodeApplied = '';
                    m.CouponCodeExTax = 0;
                    m.CouponCodeTax = 0;
                    m.CouponCodeIncTax = 0;
                    m.ExtraDays = '';
                    m.ExtraMonths = '';
                    m.PriceAfterCoupon = 0;
                    m.TaxAfterCoupon = 0;
                    m.TotalAmountAfterCoupon = 0;
                    m.NoFinancialDis = false;
                }

                return m;
            })

            saveState(sessionKey7, membershipPackagesObj);

            return {
                ...state, MembershipPackages: membershipPackagesObj
            }
        }

        case SHOPCART_SET_MANAGEMYBOOKING: {
            let managemybooking = { ...state.managemybooking };
            let managebkngticketsmodification = { ...state.managebookingticketsmodification };

            managemybooking = action.payload.managebooking;
            managebkngticketsmodification = action.payload.managebookingmodifytickets;

            saveState(sessionKey9, managemybooking);
            saveState(sessionKey10, managebkngticketsmodification);

            return {
                ...state, managemybooking: managemybooking, managebookingticketsmodification: managebkngticketsmodification
            }
        }

        case SHOPCART_SET_REFUNDTYPE: {
            let refundTyp = { ...state.refundType };

            refundTyp = action.payload.refundType;
            saveState(sessionKey11, refundTyp);

            return {
                ...state, refundType: refundTyp
            }
        }

        case SHOPCART_SET_ADDITIONALBOOKING_AMOUNT: {
            let additionalbookingamt = { ...state.additionalbookingamount };
            additionalbookingamt = action.payload.amount;

            return {
                ...state, additionalbookingamount: additionalbookingamt
            }
        }

        case SHOPCART_SET_MMB_AMOUNT_TO_PAY: {
            let mmbAmountToPay = { ...state.mmbAmountToPay };
            mmbAmountToPay = action.payload.amounttopay;

            saveState(sessionKey12, mmbAmountToPay);

            return {
                ...state, mmbAmountToPay: mmbAmountToPay
            }

        }

        case SHOPCART_SET_ENTERED_AMOUNT_TO_PAY: {
            let enteredAmountToPay = { ...state.enteredAmountToPay };
            enteredAmountToPay = action.payload.enteredAmountToPay;

            saveState(sessionKey17, enteredAmountToPay);

            return {
                ...state, enteredAmountToPay: enteredAmountToPay
            }
        }

        case SHOPCART_APPLY_MEMBER_COSTRATE: {

            var membershipObj = {
                ismembershipApplied: true,
                membershipcostrate: action.payload.costrate,
                membershipMembrNo: action.payload.memberNo,
                memberEmail: action.payload.memberEmail,
                memberLastName: action.payload.memberLastName,
                applycostRates: true
            }

            saveState(sessionKey5, membershipObj)

            return {
                ...state,
                membershipValidation: membershipObj
            };
        }

        case SHOPCART_APPLY_IDME_COSTRATES_ON_EVENTS: {

            let newevents = [
                ...state.events
            ]

            var idmeObj = {
                isIdMeApplied: true,
                idmecostrate: action.payload.costrate
            }

            var membershipObj = {
                ismembershipApplied: false,
                membershipcostrate: DefaultCostRateID,
                membershipMembrNo: 0,
                memberEmail: "",
                memberLastName: "",
                applycostRates: false
            }

            newevents = genfunction.ApplyMembershipPricesOnEvents(newevents, action.payload.costrate, action.payload.extraitems, DefaultCostRateID);

            saveState(sessionKey, newevents);
            saveState(sessionKey5, membershipObj);
            saveState(sessionKey13, idmeObj);

            return {
                ...state,
                events: newevents,
                IDME: idmeObj,
                membershipValidation: membershipObj
            };

        }
        case SHOPCART_ADD_ORDER_PRODUCT: {
            let newOrderProduct = [
                ...state.orderProducts,
                action.payload
            ]

            saveState(sessionKey14, newOrderProduct);

            return {
                ...state,
                orderProducts: newOrderProduct,
                loading: false
            };
        }
        case SHOPCART_UPDATE_ORDER_PRODUCT: {
            let newOrderProduct = [
                ...state.orderProducts,
            ]

            let fp = newOrderProduct.find(x => x.UniqueID === action.payload.UniqueID);
            fp = action.payload;

            saveState(sessionKey14, newOrderProduct);

            return {
                ...state,
                orderProducts: newOrderProduct,
                loading: false
            };
        }
        case SHOPCART_UPDATE_ORDER_PRODUCTS: {
            let newOrderProduct = [
                ...action.payload
            ]

            saveState(sessionKey14, newOrderProduct);

            return {
                ...state,
                orderProducts: newOrderProduct,
                loading: false
            };
        }
        case SHOPCART_DELETE_ORDER_PRODUCT: {
            let newOrderProduct = [
                ...state.orderProducts,
            ]

            newOrderProduct = newOrderProduct.filter(x => x.UniqueID !== action.payload.UniqueID);

            saveState(sessionKey14, newOrderProduct);

            return {
                ...state,
                orderProducts: newOrderProduct,
                loading: false
            };
        }

        case SHOPCART_SHOW_TRANSACTION_FEE: {
            let showTransFee = { ...state.showTransactionFee };
            showTransFee = action.payload;
            saveState(sessionKey15, showTransFee);

            return {
                ...state,
                showTransactionFee: showTransFee,
                loading: false
            };
        }

        case SHOPCART_UPDATE_DONATION_PRODUCT: {
            let donationProducts = [...state.donationProducts];
            let newdonationProducts = action.payload;

            newdonationProducts.forEach(newdonationproduct => {
                donationProducts = donationProducts.filter(x => x.ProductID != newdonationproduct.ProductID);
                donationProducts.push(newdonationproduct);
            });

            saveState(sessionKey16, donationProducts);
            return {
                ...state,
                donationProducts: donationProducts,
                loading: false
            }
        }

        case SHOPCART_DELETE_DONATION_PRODUCT: {
            let donationProducts = [...state.donationProducts];
            let productID = action.payload;
            donationProducts = donationProducts.filter(x => x.ProductID != productID);
            saveState(sessionKey16, donationProducts);
            return {
                ...state,
                donationProducts: donationProducts,
                loading: false
            }
        }

        case SHOPCART_RESET_DONATION_PRODUCT: {
            saveState(sessionKey16, []);

            return {
                ...state,
                donationProducts: []
            };
        }

        case SHOPCART_ERROR: {

            return {
                ...state,
                error: action.error
            }
        }

        case SHOPCART_RESET_ERROR: {
            return {
                ...state,
                error: ''
            }
        }
    }
}

export default reducerShopCart;
